export const productionConfig = {
  apiKey: "AIzaSyCrENOGTpiFgIwoh6gt9TNsGJHPW2A3Wl4",
  authDomain: "loop-60b76.firebaseapp.com",
  databaseURL: "https://loop-60b76.firebaseio.com",
  projectId: "loop-60b76",
  storageBucket: "gs://loop-60b76.appspot.com",
  stripeKey: "pk_live_sud23HmFh5HWGIAAbgxhO1fr",
  functionURL: "https://us-central1-loop-60b76.cloudfunctions.net",
  appId: "1:1078162366945:ios:5e27b165400dd191",
  messagingSenderId: "1078162366945",
};



// WEBPACK FOOTER //
// ./src/redux/config/prod.js